(function () {
  const DEBOUNCE_MS = 280;
  const ROWS_SECTION_ID = 'collection-product-table-rows';
  const collectionRowsCache = new Map();
  const Qty = () => window.GastonQuantityStepper;

  function syncVariantRow(select) {
    const row = select.closest('[data-product-table-row]');
    if (!row) return;
    const opt = select.options[select.selectedIndex];
    if (!opt) return;

    row.querySelectorAll('[data-product-table-price]').forEach((priceEl) => {
      priceEl.textContent = opt.dataset.priceLine || '';
    });

    const variantIdInput =
      row.querySelector('[data-product-table-variant-id]') || row.querySelector('[data-product-table-variant]');
    if (variantIdInput) {
      variantIdInput.value = opt.value || '';
    }

    const qtyStepper = row.querySelector('[data-product-table-qty-stepper]');
    if (qtyStepper && select.matches('[data-product-table-variant]')) {
      const config = {
        mode: opt.dataset.qtyMode || 'piece',
        min: parseInt(opt.dataset.qtyMin, 10) || 1,
        max: opt.dataset.qtyMax ? parseInt(opt.dataset.qtyMax, 10) : null,
        step: parseInt(opt.dataset.qtyIncrement, 10) || 1,
        measureValue: parseFloat(opt.dataset.qtyMeasureValue) || 1,
        measureUnit: opt.dataset.qtyMeasureUnit || 'g',
      };
      if (config.mode === 'weight') config.step = 1;

      const productOrderMin = row.dataset.productOrderMinimum
        ? parseInt(row.dataset.productOrderMinimum, 10)
        : null;
      if (productOrderMin != null && !Number.isNaN(productOrderMin)) {
        config.min = Math.max(config.min, productOrderMin);
      }

      qtyStepper.dataset.qtyMode = config.mode;
      qtyStepper.dataset.qtyMin = String(config.min);
      if (config.max != null) qtyStepper.dataset.qtyMax = String(config.max);
      else delete qtyStepper.dataset.qtyMax;
      qtyStepper.dataset.qtyStep = String(config.step);
      if (config.mode === 'weight') {
        qtyStepper.dataset.qtyMeasureValue = String(config.measureValue);
        qtyStepper.dataset.qtyMeasureUnit = config.measureUnit;
      }

      const qtyInput = qtyStepper.querySelector('[data-product-table-quantity]');
      let v = parseInt(qtyInput?.value, 10);
      if (Number.isNaN(v)) v = config.min;
      v = Math.max(config.min, config.max != null ? Math.min(config.max, v) : v);
      Qty()?.apply(qtyStepper, v, config);
    }

    const addBtn = row.querySelector('.product-table__add');
    if (addBtn) {
      const unavailable = opt.dataset.available === 'false' || !opt.value;
      addBtn.toggleAttribute('disabled', unavailable);
    }

    const form = row.querySelector('[data-type="add-to-cart-form"]');
    if (form) {
      let propInput = form.querySelector('[data-gaston-weight-property]');
      if (!propInput) {
        propInput = document.createElement('input');
        propInput.type = 'hidden';
        propInput.name = 'properties[_gaston_weight_based]';
        propInput.dataset.gastonWeightProperty = '';
        form.appendChild(propInput);
      }
      if (opt.dataset.qtyMode === 'weight') {
        propInput.disabled = false;
        propInput.value = 'true';
      } else {
        propInput.value = '';
        propInput.disabled = true;
      }
    }
  }

  function walkVariantSelect(select, direction) {
    const opts = Array.from(select.options);
    const i = select.selectedIndex;
    if (direction === 'prev') {
      for (let j = i - 1; j >= 0; j--) {
        if (!opts[j].disabled) {
          select.selectedIndex = j;
          return;
        }
      }
    } else {
      for (let j = i + 1; j < opts.length; j++) {
        if (!opts[j].disabled) {
          select.selectedIndex = j;
          return;
        }
      }
    }
  }

  function normalizeQuery(q) {
    return (q || '').trim().toLowerCase();
  }

  function queryTerms(query) {
    return normalizeQuery(query).split(/\s+/).filter(Boolean);
  }

  function rowMatchesQuery(row, query) {
    const index = (row.dataset.searchIndex || '').toLowerCase();
    const terms = queryTerms(query);
    if (!index || terms.length === 0) return false;
    return terms.every((term) => index.includes(term));
  }

  function parseRowsFromHtml(html) {
    const doc = new DOMParser().parseFromString(`<table><tbody>${html}</tbody></table>`, 'text/html');
    return Array.from(doc.querySelectorAll('[data-product-table-row]'));
  }

  function mergeSearchRows(originalRows, apiRows, query) {
    const byId = new Map();

    apiRows.forEach((row) => {
      if (!rowMatchesQuery(row, query)) return;
      byId.set(row.dataset.productId, row);
    });

    originalRows.forEach((row) => {
      if (!rowMatchesQuery(row, query)) return;
      byId.set(row.dataset.productId, row);
    });

    return Array.from(byId.values());
  }

  function groupRowsByType(rows, root) {
    const showCategoryColumn = root?.dataset.showCategoryColumn === 'true';
    const showTypeHeaders = root?.dataset.showTypeHeaders === 'true';
    const colspan = showCategoryColumn ? 6 : 5;

    const byPosition = [...rows].sort((a, b) => {
      const posA = parseInt(a.dataset.collectionPosition, 10);
      const posB = parseInt(b.dataset.collectionPosition, 10);
      return (Number.isNaN(posA) ? 0 : posA) - (Number.isNaN(posB) ? 0 : posB);
    });

    const typesInOrder = [];
    byPosition.forEach((row) => {
      const type = row.dataset.productType || '';
      if (type && !typesInOrder.includes(type)) typesInOrder.push(type);
    });

    const grouped = [];

    const otherProductsLabel = root?.dataset.otherProductsLabel || 'Andere producten';
    const untypedRows = byPosition.filter((row) => !(row.dataset.productType || '').trim());

    typesInOrder.forEach((type) => {
      if (showTypeHeaders) {
        const header = document.createElement('tr');
        header.className = 'product-table__group';
        header.dataset.productTableGroup = '';
        header.dataset.productTypeGroup = type;
        const cell = document.createElement('th');
        cell.scope = 'colgroup';
        cell.colSpan = colspan;
        cell.className = 'product-table__group-cell';
        const title = document.createElement('span');
        title.className = 'product-table__group-title';
        title.textContent = type;
        cell.appendChild(title);
        header.appendChild(cell);
        grouped.push(header);
      }

      byPosition
        .filter((row) => {
          const rowType = (row.dataset.productType || '').trim();
          return rowType && rowType === type;
        })
        .forEach((row) => grouped.push(row));
    });

    if (showTypeHeaders && typesInOrder.length > 0 && untypedRows.length > 0) {
      const header = document.createElement('tr');
      header.className = 'product-table__group';
      header.dataset.productTableGroup = '';
      header.dataset.productTypeGroup = '__other__';
      const cell = document.createElement('th');
      cell.scope = 'colgroup';
      cell.colSpan = colspan;
      cell.className = 'product-table__group-cell';
      const title = document.createElement('span');
      title.className = 'product-table__group-title';
      title.textContent = otherProductsLabel;
      cell.appendChild(title);
      header.appendChild(cell);
      grouped.push(header);
    }

    untypedRows.forEach((row) => grouped.push(row));

    return grouped;
  }

  function getSearchCollectionPath(searchCatalogUrl) {
    if (!searchCatalogUrl) return window.location.pathname;
    return new URL(searchCatalogUrl, window.location.origin).pathname;
  }

  function preloadCollectionRows(collectionPath) {
    if (!collectionPath) return;
    loadCollectionRows(collectionPath).catch(() => {});
  }

  async function fetchCollectionRowsPage(collectionPath, page, signal) {
    const url = new URL(collectionPath, window.location.origin);
    url.searchParams.set('section_id', ROWS_SECTION_ID);
    if (page > 1) url.searchParams.set('page', String(page));

    const res = await fetch(url.toString(), { signal });
    if (!res.ok) throw new Error(String(res.status));
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const meta = doc.querySelector('[data-product-table-rows-meta]');
    const rows = Array.from(doc.querySelectorAll('[data-product-table-row]'));
    const totalPages = parseInt(meta?.dataset.totalPages || '1', 10);
    return { rows, totalPages };
  }

  async function loadCollectionRows(collectionPath, signal) {
    const cached = collectionRowsCache.get(collectionPath);
    if (Array.isArray(cached)) return cached;
    if (cached instanceof Promise) return cached;

    const loadPromise = (async () => {
      const first = await fetchCollectionRowsPage(collectionPath, 1, signal);
      const allRows = [...first.rows];

      if (first.totalPages > 1) {
        const pages = await Promise.all(
          Array.from({ length: first.totalPages - 1 }, (_, index) =>
            fetchCollectionRowsPage(collectionPath, index + 2, signal)
          )
        );
        pages.forEach(({ rows }) => allRows.push(...rows));
      }

      collectionRowsCache.set(collectionPath, allRows);
      return allRows;
    })();

    collectionRowsCache.set(collectionPath, loadPromise);

    try {
      return await loadPromise;
    } catch (err) {
      collectionRowsCache.delete(collectionPath);
      throw err;
    }
  }

  function stripCategoryCells(root) {
    if (root.dataset.showCategoryColumn === 'true') return;
    root.querySelectorAll('.product-table__cell--meta').forEach((cell) => cell.remove());
  }

  function initQtySteppers(root) {
    root.querySelectorAll('[data-product-table-qty-stepper]').forEach((stepper) => {
      const config = Qty()?.parseConfig(stepper);
      const input = stepper.querySelector('[data-product-table-quantity]');
      const v = parseInt(input?.value, 10) || config.min;
      Qty()?.apply(stepper, v, config);
    });
  }

  function noteModalForRow(row) {
    const productId = row?.dataset.productId;
    if (!productId) return null;
    return document.querySelector(`modal-dialog.product-table-note-modal[data-product-id="${productId}"]`);
  }

  function syncNoteFieldFromRow(row) {
    const noteInput = row?.querySelector('[data-product-table-note-input]');
    const noteField = noteModalForRow(row)?.querySelector('[data-product-table-note-field]');
    if (noteField && noteInput) noteField.value = noteInput.value || '';
  }

  function applyNoteToRow(row, value) {
    const trimmed = (value || '').trim();
    const noteInput = row?.querySelector('[data-product-table-note-input]');
    const noteTrigger = row?.querySelector('[data-product-table-note-trigger]');
    if (noteInput) {
      noteInput.value = trimmed;
      noteInput.disabled = !trimmed;
    }
    noteTrigger?.classList.toggle('product-table__note-btn--has-note', !!trimmed);
  }

  function rowFromNoteModal(modal) {
    const fromOpener = modal?.openedBy?.closest('[data-product-table-row]');
    if (fromOpener) return fromOpener;
    const productId = modal?.dataset.productId;
    if (!productId) return null;
    const root = modal.openedBy?.closest('[data-collection-product-table]');
    return root?.querySelector(`[data-product-table-row][data-product-id="${productId}"]`) || null;
  }

  if (!document.documentElement.dataset.productTableNotesBound) {
    document.documentElement.dataset.productTableNotesBound = 'true';
    document.addEventListener('click', (e) => {
      const noteSave = e.target.closest('[data-product-table-note-save]');
      if (!noteSave) return;

      const modal = noteSave.closest('modal-dialog.product-table-note-modal');
      if (!modal) return;

      const row = rowFromNoteModal(modal);
      const noteField = modal.querySelector('[data-product-table-note-field]');
      applyNoteToRow(row, noteField?.value || '');
      modal.hide();
    });
  }

  function init(root) {
    const searchInput = root.querySelector('[data-product-table-search]');
    const emptyMsg = root.querySelector('[data-product-table-empty]');
    const resetBtn = root.querySelector('[data-product-table-reset]');
    const onAllPage = root.dataset.onAllPage === 'true';
    const resetUrl = root.dataset.resetUrl;
    const searchCatalogUrl = root.dataset.searchCatalogUrl;
    const tbody = root.querySelector('[data-product-table-body]');
    const paginationWrap = root.querySelector('[data-product-table-pagination]');
    const scroll = root.querySelector('.product-table__scroll');

    let originalTbodyInner = tbody ? tbody.innerHTML : '';
    let searchAbort = null;
    let searchDebounceTimer = null;

    initQtySteppers(root);
    stripCategoryCells(root);

    root.addEventListener('change', (e) => {
      const t = e.target;
      if (t && t.matches && t.matches('[data-product-table-variant]')) syncVariantRow(t);
    });

    root.addEventListener('click', (e) => {
      const noteTrigger = e.target.closest('[data-product-table-note-trigger]');
      if (noteTrigger && root.contains(noteTrigger)) {
        const row = noteTrigger.closest('[data-product-table-row]');
        syncNoteFieldFromRow(row);
        return;
      }

      const qtyBtn = e.target.closest('[data-qty-step]');
      if (qtyBtn && root.contains(qtyBtn)) {
        const stepper = qtyBtn.closest('[data-product-table-qty-stepper]');
        if (!stepper || qtyBtn.disabled) return;
        const previous = stepper.querySelector('[data-product-table-quantity]')?.value;
        Qty()?.walk(stepper, qtyBtn.dataset.qtyStep);
        const input = stepper.querySelector('[data-product-table-quantity]');
        if (input && previous !== input.value) {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      const btn = e.target.closest('[data-variant-step]');
      if (!btn || !root.contains(btn)) return;
      const row = btn.closest('[data-product-table-row]');
      const select = row?.querySelector('[data-product-table-variant]');
      if (!select) return;
      walkVariantSelect(select, btn.dataset.variantStep);
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });

    async function runSearch(q) {
      const query = (q || '').trim();

      if (!query) {
        searchAbort?.abort();
        if (tbody) tbody.innerHTML = originalTbodyInner;
        if (paginationWrap) paginationWrap.hidden = false;
        if (emptyMsg) {
          emptyMsg.hidden = true;
          emptyMsg.classList.add('hidden');
        }
        root.classList.remove('product-table--searching');
        scroll?.setAttribute('aria-busy', 'false');
        initQtySteppers(root);
        stripCategoryCells(root);
        return;
      }

      searchAbort?.abort();
      searchAbort = new AbortController();
      const { signal } = searchAbort;

      root.classList.add('product-table--searching');
      scroll?.setAttribute('aria-busy', 'true');
      if (paginationWrap) paginationWrap.hidden = true;

      try {
        const searchCollectionPath = getSearchCollectionPath(searchCatalogUrl);
        const catalogRows = await loadCollectionRows(searchCollectionPath, signal);
        const originalRows = parseRowsFromHtml(originalTbodyInner);
        const matchedRows = mergeSearchRows(originalRows, catalogRows, query);
        const groupedRows = groupRowsByType(matchedRows, root);
        const rowCount = matchedRows.length;

        if (tbody) {
          tbody.innerHTML = groupedRows.map((row) => row.outerHTML).join('');
        }

        if (emptyMsg) {
          const hasRows = rowCount > 0;
          emptyMsg.hidden = hasRows;
          emptyMsg.classList.toggle('hidden', hasRows);
        }

        initQtySteppers(root);
        stripCategoryCells(root);
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        console.error(err);
      } finally {
        root.classList.remove('product-table--searching');
        scroll?.setAttribute('aria-busy', 'false');
      }
    }

    function scheduleSearch() {
      clearTimeout(searchDebounceTimer);
      searchDebounceTimer = setTimeout(() => {
        runSearch(searchInput?.value || '');
      }, DEBOUNCE_MS);
    }

    searchInput?.addEventListener('input', scheduleSearch);

    resetBtn?.addEventListener('click', () => {
      searchAbort?.abort();
      clearTimeout(searchDebounceTimer);
      if (searchInput) searchInput.value = '';
      if (!onAllPage && resetUrl) {
        window.location.href = resetUrl;
        return;
      }
      runSearch('');
    });

    preloadCollectionRows(getSearchCollectionPath(searchCatalogUrl));
  }

  document.querySelectorAll('[data-collection-product-table]').forEach(init);
})();
